import { Component, ChangeDetectionStrategy } from '@angular/core';

import { ToolComponent } from '@ximple/igo2-common';
import { IgoMap } from '@ximple/igo2-geo';

import { MapState } from '../../map/map.state';

@ToolComponent({
  name: 'importExport',
  title: 'igo.integration.tools.importExport',
  icon: 'file-move'
})
@Component({
  selector: 'igo-import-export-tool',
  templateUrl: './import-export-tool.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImportExportToolComponent {
  /**
   * Map to measure on
   * @internal
   */
  get map(): IgoMap { return this.mapState.map; }

  constructor(
    private mapState: MapState
  ) {}

}
